import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getToken } from '../../services/auth';

interface Props {
  patientId: string;
  compact?: boolean;
}

export default function PaymentBadge({ patientId, compact }: Props) {
  const [status, setStatus] = useState<string | null>(null);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (!patientId) return;
    const headers = { Authorization: `Bearer ${getToken()}` };
    axios.get(`/api/patients/${patientId}/balance`, { headers })
      .then((r) => {
        setStatus(r.data?.status || null);
        setBalance(r.data?.balance || 0);
      })
      .catch(() => {});
  }, [patientId]);

  if (!status || status === 'NO_BILLS') return null;

  const colors: Record<string, { bg: string; fg: string; border: string }> = {
    PAID: { bg: 'rgba(5,150,105,0.1)', fg: '#059669', border: 'rgba(5,150,105,0.25)' },
    PARTIAL: { bg: 'rgba(245,158,11,0.1)', fg: '#d97706', border: 'rgba(245,158,11,0.25)' },
    UNPAID: { bg: 'rgba(220,38,38,0.1)', fg: '#dc2626', border: 'rgba(220,38,38,0.25)' },
  };

  const c = colors[status] || colors.UNPAID;

  if (compact) {
    return (
      <span style={{
        display: 'inline-block', width: 8, height: 8, borderRadius: '50%',
        background: c.fg, marginLeft: 4, verticalAlign: 'middle',
        boxShadow: `0 0 4px ${c.fg}40`,
      }} title={`${status} — ₹${balance.toLocaleString('en-IN')}`} />
    );
  }

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600,
      background: c.bg, color: c.fg, border: `1px solid ${c.border}`,
    }}>
      ₹{balance > 0 ? balance.toLocaleString('en-IN') : status}
    </span>
  );
}
